import { FC, useState } from 'react';
import {
  TextFieldProps,
  TextField,
  IconButton,
  InputAdornment,
  SxProps,
} from '@mui/material';
import { VisibilityIcon } from 'components/icons/Visibility';
import { VisibilityOffIcon } from 'components/icons/VisibilityOff';
import { PasswordLockIcon } from 'components/icons/PasswordLockIcon';
import { styles } from './styles';
import { EnvelopeIcon } from 'components/icons/EnvelopeIcon';

type InputProps = TextFieldProps & {
  customProp?: string;
  startIcon?: React.ReactNode;
  endIcon?: React.ReactNode;
  shouldInputValidate?: boolean;
};
export const Input: FC<InputProps> = ({
  error,
  helperText,
  value,
  type,
  placeholder,
  onChange,
  startIcon,
  endIcon,
  shouldInputValidate = true,
  ...rest
}) => {
  const [showPassword, setShowPassword] = useState<boolean>(false);
  const togglePasswordVisibility = () => setShowPassword((prev) => !prev);

  const inputType =
    type === 'password' ? (showPassword ? 'text' : 'password') : type;

  return (
    <TextField
      {...rest}
      inputRef={rest.inputRef}
      type={inputType}
      placeholder={placeholder}
      variant="outlined"
      value={value}
      onChange={onChange}
      sx={{ ...styles.root, ...rest.sx } as SxProps}
      error={!!error}
      helperText={helperText}
      onWheel={(event) =>
        event.target instanceof HTMLElement && event.target.blur()
      }
      InputProps={{
        startAdornment: startIcon ? (
          <InputAdornment position="start">{startIcon}</InputAdornment>
        ) : type === 'password' ? (
          <InputAdornment position="start">
            <PasswordLockIcon className="h-6 w-6" />
          </InputAdornment>
        ) : type === 'email' ? (
          <InputAdornment position="start">
            <EnvelopeIcon className="h-6 w-6" />
          </InputAdornment>
        ) : null,
        endAdornment: endIcon ? (
          <InputAdornment position="end">{endIcon}</InputAdornment>
        ) : type === 'password' ? (
          <InputAdornment position="end">
            <IconButton
              onClick={togglePasswordVisibility}
              edge="end"
              disableRipple
            >
              {showPassword ? (
                <VisibilityIcon className="mr-4 h-6 w-6 text-mult hover:text-blue" />
              ) : (
                <VisibilityOffIcon className="mr-4 h-6 w-6 text-mult hover:text-blue" />
              )}
            </IconButton>
          </InputAdornment>
        ) : null,
      }}
    />
  );
};
